import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { ApiService } from 'src/app/service/apiServices';
declare var jquery: any;
declare var $: any;
import Swal from 'sweetalert2';
import { Global } from '../../../global';
import { AuthService } from '../../../service/auth/auth.service'

@Component({
  selector: 'app-servico-painel-senha-list',
  templateUrl: './servico-painel-senha-list.component.html',
  styleUrls: ['./servico-painel-senha-list.component.css']
})
export class ServicoPainelSenhaListComponent implements OnInit {

  listServicos: any = [];
  filtroNome: string = "";
  filtroAtivo: any = null;
  listaEstabelecimentos: any = [];
  filtroEstabelecimentoId: any = null;
  loading: boolean = false;
  currentUser: any = JSON.parse(localStorage.getItem('@DigtVentry:currentUser'));
  presencaUser: any = JSON.parse(localStorage.getItem('@DigtVentry:presencaUser'));

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private alerts: NgxAlertsService,
    private router: Router,
    private global: Global,
    private authService: AuthService
  ) {
    
   }

  ngOnInit() {
    this.carregarEstabelecimentos();
    
  }

  carregarEstabelecimentos() {
    this.service.Get(`Estabelecimento?Ativo=true`).then((res: any) => {
      this.listaEstabelecimentos = res || [];

      try {
        const presenca = JSON.parse(localStorage.getItem('@DigtVentry:presencaUser'));
        if (presenca && presenca.estabelecimento_id) {
          this.filtroEstabelecimentoId = presenca.estabelecimento_id;
        } else {
          const user = JSON.parse(localStorage.getItem('@DigtVentry:currentUser'));
          if (user && user.estabelecimento_id) {
            this.filtroEstabelecimentoId = user.estabelecimento_id;
          }
        }
      } catch (e) {
        this.filtroEstabelecimentoId = null;
      }

      this.getListServicos();
    }).catch(err => {
      console.error('Erro ao carregar estabelecimentos', err);
      this.getListServicos();
    });
  }

  confirmationAtivarDesativar = (id, ativo) => {
    Swal.fire({
      title: 'Atenção',
      text: `Tem certeza que deseja ${ativo ? "ativar" : "desativar"} esse Serviço?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire('Favor aguarde');
          Swal.showLoading();
          this.service.AtivarDesativar(`ServicoPainelSenha/${id}`, ativo).then((res) => {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              html: 'Operação realizada com sucesso!'
            }).then(
              result => {
                if (result.isConfirmed) {
                  this.getListServicos();
                }
              }
            );
          }).catch((err) => {
            Swal.close();
            if (err && err.error && err.error.erros && err.error.erros[0]) {
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                html: err.error.erros[0].messagem
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                html: 'Ocorreu um erro ao processar a solicitação'
              });
            }
          })
        }
      }
    );
  }

  confirmationResetarTodas = () => {
    Swal.fire({
      title: 'Atenção',
      text: 'Tem certeza que deseja resetar a senha de todos os serviços?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(result => {
      if (!result.isConfirmed) {
        return;
      }

      Swal.fire('Favor aguarde');
      Swal.showLoading();

      this.service.Patch_body('ServicoPainelSenha/Resetar', {}).then(() => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          html: 'Senhas resetadas com sucesso!'
        }).then(r => {
          if (r.isConfirmed) {
            this.getListServicos();
          }
        });
      }).catch((err) => {
        Swal.close();

        if (err && (err.status == 401 || (err.error && err.error.status == 401))) {
          this.authService.logoutUser();
          return;
        }

        if (err && err.error && err.error.erros && err.error.erros[0]) {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            html: err.error.erros[0].messagem
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            html: 'Ocorreu um erro ao resetar as senhas'
          });
        }
      });
    });
  }

  confirmationResetarIndividual = (id: any) => {
    Swal.fire({
      title: 'Atenção',
      text: 'Tem certeza que deseja resetar a senha desse serviço?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(result => {
      if (!result.isConfirmed) {
        return;
      }

      Swal.fire('Favor aguarde');
      Swal.showLoading();

      this.service.Patch_body(`ServicoPainelSenha/${id}/Resetar`, {}).then(() => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          html: 'Senha resetada com sucesso!'
        }).then(r => {
          if (r.isConfirmed) {
            this.getListServicos();
          }
        });
      }).catch((err) => {
        Swal.close();

        if (err && (err.status == 401 || (err.error && err.error.status == 401))) {
          this.authService.logoutUser();
          return;
        }

        if (err && err.error && err.error.erros && err.error.erros[0]) {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            html: err.error.erros[0].messagem
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            html: 'Ocorreu um erro ao resetar a senha'
          });
        }
      });
    });
  }

  emitError = (error) => {
    if (typeof error == 'string') {
      Swal.fire('Erro', `${error}`, 'error');
      return
    }
    if (error.status == 401 || error.error.status == 401) {
      Swal.close()
      this.authService.logoutUser()
    }
    if (error.status === 404) {
      Swal.fire('Atenção', `${error.error}`, 'warning');
      return
    }
    if (error.status) {
      Swal.fire({ icon: 'error', title: 'Erro', html: `${error.status} - ${error.error.erros[0].messagem}` })
      return
    }
    if (error.alert) {
      Swal.fire('Atenção', `${error.txt}`, 'warning');
      return
    }
  }

  emitAlert = () => {
    Swal.close()
    this.alerts.notifyError({
      body: `Erro`,
      title: 'Erro'
    });
  }

  getListServicos = () => {
    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();

    var url = `ServicoPainelSenha`;
    var params: string[] = [];

    if (this.filtroNome) {
      params.push(`nome=${this.filtroNome}`);
    }

    if (this.filtroAtivo !== null && this.filtroAtivo !== undefined && this.filtroAtivo !== '') {
      params.push(`ativo=${this.filtroAtivo}`);
    }

    if (this.filtroEstabelecimentoId !== null && this.filtroEstabelecimentoId !== undefined && this.filtroEstabelecimentoId !== '') {
      params.push(`estabelecimento_id=${this.filtroEstabelecimentoId}`);
    }

    if (params.length > 0) {
      url = url + '?' + params.join('&');
    }

    this.service.Get(url).then(res => {
      this.listServicos = res || [];
      Swal.close();
      this.loading = false;
    }).catch(res => {
      this.listServicos = [];
      Swal.close();
      this.loading = false;

      if (res && res.status == 401 || (res && res.error && res.error.status == 401)) {
        this.authService.logoutUser()
        return;
      }

      if (res && res.error && res.error.erros && res.error.erros[0]) {
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      } else {
        Swal.fire('Erro', 'Ocorreu um erro ao buscar os serviços', 'error');
      }
    });
  }

  obterListaFiltros() {
    this.getListServicos();
  }

  limparFiltros() {
    this.filtroNome = "";
    this.filtroAtivo = null;
    this.getListServicos();
  }
}
